import { FormControl, MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';

export function LandingPageReportDownload() {

	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state?.epiProps?.clergyCompReportSettingsState?.epiContent);
	const [value, setValue] = useState('');
	const handleChange = (evt) => {
		if (!evt?.target?.value) return;

		const report = document.createElement('a');
		report.href = evt?.target?.value;
		const stringList = evt?.target?.value?.split('/');
		report.download = stringList[stringList.length - 1];
		report.click();
		report.remove();
		setValue(evt?.target?.value);
	};

	return (
		<FormControl className='clergycomp-infographic-dropdown'>
			<Select
				value={value}
				onChange={handleChange}
				placeholder={settings?.downloadReportDropdownTitle}
				displayEmpty
				renderValue={(selected: any) => {
					if (selected?.length === 0) {
						return <em>{settings?.downloadReportDropdownTitle}</em>;
					}
					const link = settings?.reportDownloadLinks?.filter(a => a.friendlyUrl === selected);
					return link[0]?.linkText;
				}}
			>
				{
					settings?.reportDownloadLinks?.map(a => <MenuItem key={a.externalLinkUrl} value={a.friendlyUrl}>{a.linkText}</MenuItem>)
				}

			</Select>
		</FormControl>
	);
}